export const UPLOAD_USER_FONT = 'UPLOAD_USER_FONT';
export const SET_USER_FONTS = 'SET_USER_FONTS';
export const GET_USER_FONTS = 'GET_USER_FONTS';
export const DELETE_USER_FONT = 'DELETE_USER_FONT';
